import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../view/Login'
import LoginInDemo from '../view/LoginInDemo.vue'
import Register from '../view/Register'
import ResetPwd from '../view/ResetPwd.vue'
import Home from '../view/Home'
// 安装路由
Vue.use(VueRouter);

// 配置导出路由
let vueRouter = new VueRouter({
  routes: [{
    path: "/",
    name: "Index",
    component: () => import("../view/Index.vue"),
  },
    {
      name: "circleDetail",
      path: "/circle-detail",
      component: () => import("../view/community/circle-detail"),
    },
    {
      name: "postDetail",
      path: "/post-detail/:id",
      component: () => import("../view/community/post-detail"),
    },
    {
      name: "pushPost",
      path: "/pushPost",
      component: () => import("../view/community/post-publish.vue"),
    },
    {
      name: "circleList",
      path: "/circle",
      component: () => import("../view/community/circleList.vue"),
    },
    {
      name: "postList",
      path: "/post-list/:id",
      component: () => import("../view/community/post-list"),
    },
    {
      name: "klgeekCs",
      path: "/klgeek/cs",
      component: () => import("../view/klgeek/cs-chat"),
    },
    {
      name: "creationDetail",
      path: "/creation/:id",
      component: () => import("../view/creation/detail"),
    },
    {
      name: "fakaDetail",
      path: "/fakaDetail/:id",
      component: () => import("../view/creation/faka-detail"),
    },
    {
      name: "profile",
      path: "/profile/:id",
      component: () => import("../view/profile/index.vue"),
    },
    {
      name: "discover",
      path: "/discover",
      component: () => import("../view/creation/creationList.vue"),
    },
    {
      name: "orderQuery",
      path: "/orderQuery",
      component: () => import("../view/creation/queryOrder.vue"),
    },
    {
      name: "mpPay",
      path: "/pay/:busId",
      component: () => import("../components/common/MpPay.vue"),
    },
    {
      name: "Login",
      path: '/login',
      component: Login
    },
      {
          name: "DemoLogin",
          path: '/login/demo',
          component: LoginInDemo
      },
    {
      name: "Register",
      path: '/register',
      component: Register
    },
      {
          name: "ResetPwd",
          path: '/password/reset',
          component: ResetPwd
      },
    {
      name: "Home",
      path: '/home',
      component: Home,
      children: [
        {
          name: "Chat",
          path: "/home/chat",
          meta: {
            requiresAuth: true,
          },
          component: () => import("../view/Chat"),
        },
        {
          name: "Friend",
          path: "/home/friend",
          meta: {
            requiresAuth: true,
          },
          component: () => import("../view/Friend"),
        },
        {
          name: "GROUP",
          path: "/home/group",
          component: () => import("../view/Group"),
        },
              {
                name: "Favorite",
                path: "/home/favorite",
                component: () => import("../view/Favorite"),
              },
          {
              name: "Setting",
              path: "/home/setting",
              component: () => import("../view/Setting"),
          },
        {
          name: "MyOrder",
          path: "/home/order",
          alias: ['/order'],
          meta: {
            requiresAuth: true,
          },
          component: () => import("../view/creation/buyorder"),
        } ,
        {
          name: "Creation",
          path: '/home/creation',
          component: () => import("../view/creation/creation.vue"),
          children:[
            {
              name: "explore",
              path: "/home/creation/explore",
              meta: {
                requiresAuth: true,
              },
              component: () => import("../view/creation/creationList.vue"),
            },
            {
              name: "order",
              path: "/home/creation/order",
              meta: {
                requiresAuth: true,
              },
              component: () => import("../view/creation/order"),
            },
            {
              name: "data",
              path: "/home/creation/data",
              component: () => import("../view/creation/data"),
            },
            {
              name: "document",
              path: "/home/creation/document",
              meta: {
                requiresAuth: true,
              },
              component: () => import("../view/creation/document"),
            },
            {
              name: "add",
              path: "/home/creation/add",
              meta: {
                requiresAuth: true,
              },
              component: () => import("../view/creation/add"),
            },
            {
              name: "edit",
              path: "/home/creation/edit",
              component: () => import("../view/creation/edit"),
            },
            {
              name: "detail",
              path: "/home/creation/detail/:id",
              component: () => import("../view/creation/detail"),
            },
            {
              name: "buyorder",
              path: "/home/creation/buyorder",
              meta: {
                requiresAuth: true,
              },
              component: () => import("../view/creation/buyorder"),
            },
            {
              name: "linkSetting",
              path: "/home/creation/linkSetting",
              meta: {
                requiresAuth: true,
              },
              component: () => import("../view/creation/linkSetting"),
            },
            {
              name: "faka",
              path: "/home/creation/faka",
              meta: {
                requiresAuth: true,
              },
              component: () => import("../view/creation/faka"),
            },
            {
              name: "faka-add",
              path: "/home/creation/faka-add",
              meta: {
                requiresAuth: true,
              },
              component: () => import("../view/creation/faka-add"),
            },
            {
              name: "faka-detail",
              path: "/home/creation/faka-detail/:id",
              component: () => import("../view/creation/faka-detail"),
            },
            {
              name: "mycirclelist",
              path: "/home/community/circle-list",
              component: () => import("../view/community/circle-list"),
            },
            {
              name: "circle-list",
              path: "/home/community/circleList",
              component: () => import("../view/community/circleList"),
            },
            {
              name: "post-publish",
              path: "/home/community/post-publish",
              component: () => import("../view/community/post-publish"),
            }
            ,
            {
              name: "post-list",
              path: "/home/community/post-list/:id",
              component: () => import("../view/community/post-list"),
            },
            {
              name: "circle-detail",
              path: "/home/community/circle-detail",
              component: () => import("../view/community/circle-detail"),
            },
            {
              name: "post-detail",
              path: "/home/community/post-detail/:id",
              component: () => import("../view/community/post-detail"),
            },
            {
              path: '/home/knowledgeBase/my',
              name: 'MyKnowledgeBase',
              meta: { title: '我的知识库', icon: 'documentation' },
              component: () => import('../view/knowledgeBase/my'),
            },
            {
              name: "paymentChannel",
              path: "/home/creation/paymentChannel",
              meta: {
                requiresAuth: true,
              },
              component: () => import("../view/creation/paymentChannel"),
            },
          ]
        },
      ]
    },
    {
      path: '/knowledgeBase',
      name: 'KnowledgeBase',
      meta: { title: '知识库', icon: 'documentation' },
      component: () => import('../view/knowledgeBase/index'),

    }, {
      path: '/knowledgeBase/detail/:id',
      name: 'KnowledgeBaseDetail',
      meta: { title: '知识库详情', icon: 'documentation',requiresAuth: true },
      component: () => import('../view/knowledgeBase/detail'),
    },
    {
      path: '/knowledgeBase/create',
      name: 'KnowledgeBaseCreate',
      meta: { title: '创建知识库', icon: 'documentation' },
      component: () => import('../view/knowledgeBase/edit'),
    },
    {
      path: '/knowledgeBase/my',
      name: 'MyKnowledgeBase',
      meta: { title: '我的知识库', icon: 'documentation' },
      component: () => import('../view/knowledgeBase/my'),
    },
    {
      path: '/knowledgeBase/edit/:id',
      name: 'KnowledgeBaseEdit',
      meta: { title: '编辑知识库', icon: 'documentation' },
      component: () => import('../view/knowledgeBase/edit'),
    }
  ]

});
const isMobileDevice=() =>{
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  // 检查用户代理字符串
  return /android|iPhone|iPad|iPod|windows phone|blackberry|iemobile|opera mini/i.test(userAgent);
}
vueRouter.beforeEach(async (to, from, next) => {
  console.log(to,from,next)
  if(isMobileDevice()&& to.name.includes("postList")) location.href=process.env.VUE_APP_SHARE_BASE+'/h5/#/pages/community/circle-intro?id='+to.params.id
  if( isMobileDevice() && (!to.name.includes("creationDetail") && !to.name.includes("orderQuery")
      && !to.name.includes("mpPay")&& !to.name.includes("fakaDetail")&& !to.name.includes("postDetail")
      && !to.name.includes("postList") && !to.name.includes("KnowledgeBaseDetail"))) {
    location.href=process.env.VUE_APP_SHARE_BASE+'/h5'
    return
  }
  if (to.meta?.requiresAuth && !(sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken"))) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    });
    return;
  }
  next();
})
export default vueRouter;
